import React from 'react'
import PropTypes from 'prop-types';
import { connect } from 'react-redux'
import OneAsyncSelectToRuleThemAll from '../../../shared/components/one_async_select_to_rule_them_all.jsx'

class SelectMemberLocation extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      optionsMostRecentlyReturned: []
    };
  }

  getLocations = () => {
    const { memberNumber, memberLocationsPath } = this.props
    const query = `${memberLocationsPath}?member_number=${memberNumber}`;

    return fetch(query, { credentials: 'same-origin' }).
      then((response) => { return response.json() }).
      then((json) => {
        this.setState({ optionsMostRecentlyReturned: json })

        // if there's only one, select it straightaway
        if (!this.props.value && Object.keys(json).length === 1) {
          this.props.onChange(json[Object.keys(json)[0]].value, json[Object.keys(json)[0]].label)
        }

        return json;
      })
  }

  handleSelectChange = (valueFromSelect) => {
    console.log("📍 handleSelectChange called with:", valueFromSelect);
    console.log("📍 Available options:", this.state.optionsMostRecentlyReturned);
    
    const selectedOption = this.state.optionsMostRecentlyReturned.find((option) => {
      console.log("📍 Comparing option:", option, "with valueFromSelect:", valueFromSelect);
      return option.value == valueFromSelect.value;
    });
    
    console.log("📍 Found option:", selectedOption);
    
    if (selectedOption) {
      const { value, label } = selectedOption;
      console.log("📍 Calling onChange with:", { value, label });
      this.props.onChange(value, label);
    }
  }

  render() {
    const {
      memberNumber,
      memberLocationsPath,
      label,
      value,
      errorMessage,
      onChange,
      required,
      tabIndex
    } = this.props;

    // ✅ Find the full option object for the current value
    const selectedOption = this.state.optionsMostRecentlyReturned.find(option => 
      option.value === value
    );

    return (
      <div className={ `form-group ${errorMessage ? 'has-error' : ''}` }>
        <OneAsyncSelectToRuleThemAll.Base
          labelText={ label }
          requiredInput={ required }
          tabIndex={ tabIndex }
          value={ selectedOption || value }
          onChange={ this.handleSelectChange }
          loadOptions={ this.getLocations }
          defaultOptions={ true }
        />

        { errorMessage && <span className="field-level-error">{ errorMessage }</span> }
      </div>
    )
  }
}

SelectMemberLocation.defaultProps = {
  required: false,
}

SelectMemberLocation.propTypes = {
  required:            PropTypes.bool.isRequired,
  label:               PropTypes.string.isRequired,
  memberNumber:        PropTypes.string.isRequired,
  memberLocationsPath: PropTypes.string.isRequired,
  onChange:            PropTypes.func.isRequired,

  errorMessage:        PropTypes.string,
  value:               PropTypes.oneOfType([PropTypes.string, PropTypes.number])
}

SelectMemberLocation = connect(
  (state, props) => ({
    memberNumber:         state.rails.memberNumber,
    memberLocationsPath:  state.rails.asyncHelpers.memberLocations
  })
)(SelectMemberLocation);

export default SelectMemberLocation
